import { useQuery } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import GameScreenLayout from "@/components/GameScreenLayout"
import { getCityChronicle } from "@/api/gameApi"
import { useAuth } from "@/context/AuthContext"
import { resolveProfileCityId } from "@/features/passport/guardiansCity"

export default function CityChroniclePage() {
  const [params] = useSearchParams()
  const { profile } = useAuth()
  const cityId =
    Number(params.get("cityId")) || resolveProfileCityId(profile) || undefined

  const q = useQuery({
    queryKey: ["city-chronicle", cityId],
    queryFn: () => getCityChronicle({ cityId: cityId! }),
    enabled: cityId != null,
  })

  return (
    <GameScreenLayout title="Летопись города" backTo="/play">
      {cityId == null ? (
        <p className="text-sm text-guardians-muted">Не выбран город</p>
      ) : q.isLoading ? (
        <p className="text-sm text-guardians-muted">Загрузка…</p>
      ) : (
        <ul className="space-y-2 text-sm">
          {(q.data?.items ?? []).map((item) => (
            <li
              key={item.id}
              className="border-b border-white/5 pb-2"
            >
              <p className="font-medium">{item.title}</p>
              {item.body ? (
                <p className="mt-1 text-xs text-guardians-muted">{item.body}</p>
              ) : null}
              <p className="mt-1 text-xs text-guardians-muted">
                {new Date(item.occurredAt).toLocaleString("ru-RU")}
              </p>
            </li>
          ))}
        </ul>
      )}
    </GameScreenLayout>
  )
}
